import { FC, useState } from 'react';
import { FocusStyle } from 'ui/tooltip/types';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { AiSparkle16 } from 'ui/icons/aurora/16px/AiSparkle16';
import {
  AiSparkleWrapper,
  CampaignAnalysisTextContainer,
  CampaignImg,
  CampaignMessageHeader,
  CampaignMoodText,
  CampaignName,
  CampaignTextContainer,
  Container,
} from './CampaignData.styles';

export interface CampaignData {
  imgSrc: string;
  messageTypeHeader: string;
  messageHeaderContent: string;
  moodText: string;
  name: string;
}

export const nbaCampaignDataIds = {
  nbaCampaignData: 'nba-campaign-data',
};

export const CampaignData: FC<React.PropsWithChildren<CampaignData>> = ({
  imgSrc,
  messageHeaderContent,
  messageTypeHeader,
  moodText,
  name,
}) => {
  const [isCampaignMessageHovered, setIsCampaignmessageHovered] = useState(false);
  return (
    <Container data-test={nbaCampaignDataIds.nbaCampaignData}>
      <CampaignImg src={imgSrc} height={50} width={60} alt={`campaign preview`} />
      <CampaignTextContainer>
        <CampaignName>{name}</CampaignName>
        <CampaignAnalysisTextContainer>
          <AiSparkleWrapper>
            <AiSparkle16 height={12} width={12} />
          </AiSparkleWrapper>
          <Tooltip
            $focusStyle={FocusStyle.Round}
            tooltipContent={`${messageHeaderContent}`}
            isEnabled={isCampaignMessageHovered}
          >
            <CampaignMessageHeader
              onMouseOver={() => {
                setIsCampaignmessageHovered(true);
              }}
              onMouseOut={() => {
                setIsCampaignmessageHovered(false);
              }}
            >
              {messageTypeHeader}
            </CampaignMessageHeader>
          </Tooltip>
          <CampaignMoodText>{moodText}</CampaignMoodText>
        </CampaignAnalysisTextContainer>
      </CampaignTextContainer>
    </Container>
  );
};
